module.exports = __webpack_public_path__ + "assets/icons/book-open-page-variant-fdd6.svg";